/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Bonisoft Backend API
 * Bonisoft Backend API
 * OpenAPI spec version: 1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AutoTranslateRequest,
  CodeInformation,
  CreateAdministratorUserRequest,
  DeleteApiCompaniesCurrentEmployeesEmployeeIdPasswordParams,
  ErrorResponse,
  GetApiCompaniesCurrentEmployeesRegistrationcodesRegistrationCodeParams,
  GetApiEmployeeRegistrationcodesRegistrationCodeParams,
  LocalizationEntityType,
  LoginRequest,
  LoginSuccessfulResponse,
  PasswordResetRequest,
  PostApiAdministratorusersCompaniesCompanyIdInvoicesParams,
  PostApiAdministratorusersParams,
  PostApiAuthRefreshCompanyParams,
  PostApiAuthRefreshParams,
  PostApiCompaniesCurrentTranslationsEntityTypeEntityIdAutoParams,
  PostApiEmployeeRegistrationCodeParams,
  PostApiLoginDemoDemoCodeParams,
  PostApiLoginParams,
  PostApiSeedingParams,
  PostApiUsersPasswordResetParams,
  PostApiUsersPasswordResetTokenParams,
  PostApiUsersUserIdConfirmationTokenParams,
  ProblemDetails,
  RefreshAccessTokenRequest,
  RegisterEmployeeUserByRegistrationCodeRequest,
  ResetPasswordWithTokenRequest,
  SeedRequest,
  SeedResponse
} from '../../model';

import { axiosInstance } from '../../axios-instance';




const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const postApiLogin = (
    loginRequest?: LoginRequest,
    params?: PostApiLoginParams,
 signal?: AbortSignal
) => {


      return axiosInstance<LoginSuccessfulResponse>(
      {url: `/api/login`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: loginRequest,
        params, signal
    },
      );
    }




export const getPostApiLoginMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiLogin>>, TError,{data?: LoginRequest;params?: PostApiLoginParams}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiLogin>>, TError,{data?: LoginRequest;params?: PostApiLoginParams}, TContext> => {

const mutationKey = ['postApiLogin'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiLogin>>, {data?: LoginRequest;params?: PostApiLoginParams}> = (props) => {
          const {data,params} = props ?? {};

          return  postApiLogin(data,params,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiLoginMutationResult = NonNullable<Awaited<ReturnType<typeof postApiLogin>>>
    export type PostApiLoginMutationBody = LoginRequest | undefined
    export type PostApiLoginMutationError = ErrorResponse

    export const usePostApiLogin = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiLogin>>, TError,{data?: LoginRequest;params?: PostApiLoginParams}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiLogin>>,
        TError,
        {data?: LoginRequest;params?: PostApiLoginParams},
        TContext
      > => {
      return useMutation(getPostApiLoginMutationOptions(options), queryClient);
    }
    export const postApiAuthRefreshCompany = (
    params?: PostApiAuthRefreshCompanyParams,
 signal?: AbortSignal
) => {


      return axiosInstance<LoginSuccessfulResponse>(
      {url: `/api/auth/refresh/company`, method: 'POST',
        params, signal
    },
      );
    }




export const getPostApiAuthRefreshCompanyMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiAuthRefreshCompany>>, TError,{params?: PostApiAuthRefreshCompanyParams}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiAuthRefreshCompany>>, TError,{params?: PostApiAuthRefreshCompanyParams}, TContext> => {

const mutationKey = ['postApiAuthRefreshCompany'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiAuthRefreshCompany>>, {params?: PostApiAuthRefreshCompanyParams}> = (props) => {
          const {params} = props ?? {};

          return  postApiAuthRefreshCompany(params,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiAuthRefreshCompanyMutationResult = NonNullable<Awaited<ReturnType<typeof postApiAuthRefreshCompany>>>

    export type PostApiAuthRefreshCompanyMutationError = ErrorResponse

    export const usePostApiAuthRefreshCompany = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiAuthRefreshCompany>>, TError,{params?: PostApiAuthRefreshCompanyParams}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiAuthRefreshCompany>>,
        TError,
        {params?: PostApiAuthRefreshCompanyParams},
        TContext
      > => {
      return useMutation(getPostApiAuthRefreshCompanyMutationOptions(options), queryClient);
    }
    export const postApiAuthRefresh = (
    refreshAccessTokenRequest?: RefreshAccessTokenRequest,
    params?: PostApiAuthRefreshParams,
 signal?: AbortSignal
) => {


      return axiosInstance<LoginSuccessfulResponse>(
      {url: `/api/auth/refresh`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: refreshAccessTokenRequest,
        params, signal
    },
      );
    }




export const getPostApiAuthRefreshMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiAuthRefresh>>, TError,{data?: RefreshAccessTokenRequest;params?: PostApiAuthRefreshParams}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiAuthRefresh>>, TError,{data?: RefreshAccessTokenRequest;params?: PostApiAuthRefreshParams}, TContext> => {

const mutationKey = ['postApiAuthRefresh'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiAuthRefresh>>, {data?: RefreshAccessTokenRequest;params?: PostApiAuthRefreshParams}> = (props) => {
          const {data,params} = props ?? {};

          return  postApiAuthRefresh(data,params,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiAuthRefreshMutationResult = NonNullable<Awaited<ReturnType<typeof postApiAuthRefresh>>>
    export type PostApiAuthRefreshMutationBody = RefreshAccessTokenRequest | undefined
    export type PostApiAuthRefreshMutationError = ErrorResponse

    export const usePostApiAuthRefresh = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiAuthRefresh>>, TError,{data?: RefreshAccessTokenRequest;params?: PostApiAuthRefreshParams}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiAuthRefresh>>,
        TError,
        {data?: RefreshAccessTokenRequest;params?: PostApiAuthRefreshParams},
        TContext
      > => {
      return useMutation(getPostApiAuthRefreshMutationOptions(options), queryClient);
    }
    export const postApiSeeding = (
    seedRequest?: SeedRequest,
    params?: PostApiSeedingParams,
 signal?: AbortSignal
) => {


      return axiosInstance<SeedResponse>(
      {url: `/api/seeding`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: seedRequest,
        params, signal
    },
      );
    }




export const getPostApiSeedingMutationOptions = <TError = ErrorResponse | ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiSeeding>>, TError,{data?: SeedRequest;params?: PostApiSeedingParams}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiSeeding>>, TError,{data?: SeedRequest;params?: PostApiSeedingParams}, TContext> => {

const mutationKey = ['postApiSeeding'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiSeeding>>, {data?: SeedRequest;params?: PostApiSeedingParams}> = (props) => {
          const {data,params} = props ?? {};

          return  postApiSeeding(data,params,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiSeedingMutationResult = NonNullable<Awaited<ReturnType<typeof postApiSeeding>>>
    export type PostApiSeedingMutationBody = SeedRequest | undefined
    export type PostApiSeedingMutationError = ErrorResponse | ProblemDetails

    export const usePostApiSeeding = <TError = ErrorResponse | ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiSeeding>>, TError,{data?: SeedRequest;params?: PostApiSeedingParams}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiSeeding>>,
        TError,
        {data?: SeedRequest;params?: PostApiSeedingParams},
        TContext
      > => {
      return useMutation(getPostApiSeedingMutationOptions(options), queryClient);
    }
    export const postApiLoginDemoDemoCode = (
    demoCode: string,
    params?: PostApiLoginDemoDemoCodeParams,
 signal?: AbortSignal
) => {


      return axiosInstance<LoginSuccessfulResponse>(
      {url: `/api/login/demo/${demoCode}`, method: 'POST',
        params, signal
    },
      );
    }




export const getPostApiLoginDemoDemoCodeMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiLoginDemoDemoCode>>, TError,{demoCode: string;params?: PostApiLoginDemoDemoCodeParams}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiLoginDemoDemoCode>>, TError,{demoCode: string;params?: PostApiLoginDemoDemoCodeParams}, TContext> => {

const mutationKey = ['postApiLoginDemoDemoCode'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiLoginDemoDemoCode>>, {demoCode: string;params?: PostApiLoginDemoDemoCodeParams}> = (props) => {
          const {demoCode,params} = props ?? {};

          return  postApiLoginDemoDemoCode(demoCode,params,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiLoginDemoDemoCodeMutationResult = NonNullable<Awaited<ReturnType<typeof postApiLoginDemoDemoCode>>>

    export type PostApiLoginDemoDemoCodeMutationError = ErrorResponse

    export const usePostApiLoginDemoDemoCode = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiLoginDemoDemoCode>>, TError,{demoCode: string;params?: PostApiLoginDemoDemoCodeParams}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiLoginDemoDemoCode>>,
        TError,
        {demoCode: string;params?: PostApiLoginDemoDemoCodeParams},
        TContext
      > => {
      return useMutation(getPostApiLoginDemoDemoCodeMutationOptions(options), queryClient);
    }
    export const postApiUsersUserIdConfirmationToken = (
    userId: string,
    token: string,
    params?: PostApiUsersUserIdConfirmationTokenParams,
 signal?: AbortSignal
) => {


      return axiosInstance<void>(
      {url: `/api/users/${userId}/confirmation/${token}`, method: 'POST',
        params, signal
    },
      );
    }




export const getPostApiUsersUserIdConfirmationTokenMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiUsersUserIdConfirmationToken>>, TError,{userId: string;token: string;params?: PostApiUsersUserIdConfirmationTokenParams}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiUsersUserIdConfirmationToken>>, TError,{userId: string;token: string;params?: PostApiUsersUserIdConfirmationTokenParams}, TContext> => {

const mutationKey = ['postApiUsersUserIdConfirmationToken'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiUsersUserIdConfirmationToken>>, {userId: string;token: string;params?: PostApiUsersUserIdConfirmationTokenParams}> = (props) => {
          const {userId,token,params} = props ?? {};

          return  postApiUsersUserIdConfirmationToken(userId,token,params,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiUsersUserIdConfirmationTokenMutationResult = NonNullable<Awaited<ReturnType<typeof postApiUsersUserIdConfirmationToken>>>

    export type PostApiUsersUserIdConfirmationTokenMutationError = ErrorResponse

    export const usePostApiUsersUserIdConfirmationToken = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiUsersUserIdConfirmationToken>>, TError,{userId: string;token: string;params?: PostApiUsersUserIdConfirmationTokenParams}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiUsersUserIdConfirmationToken>>,
        TError,
        {userId: string;token: string;params?: PostApiUsersUserIdConfirmationTokenParams},
        TContext
      > => {
      return useMutation(getPostApiUsersUserIdConfirmationTokenMutationOptions(options), queryClient);
    }
    export const postApiUsersPasswordReset = (
    passwordResetRequest?: PasswordResetRequest,
    params?: PostApiUsersPasswordResetParams,
 signal?: AbortSignal
) => {


      return axiosInstance<void>(
      {url: `/api/users/password_reset`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: passwordResetRequest,
        params, signal
    },
      );
    }




export const getPostApiUsersPasswordResetMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiUsersPasswordReset>>, TError,{data?: PasswordResetRequest;params?: PostApiUsersPasswordResetParams}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiUsersPasswordReset>>, TError,{data?: PasswordResetRequest;params?: PostApiUsersPasswordResetParams}, TContext> => {

const mutationKey = ['postApiUsersPasswordReset'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiUsersPasswordReset>>, {data?: PasswordResetRequest;params?: PostApiUsersPasswordResetParams}> = (props) => {
          const {data,params} = props ?? {};

          return  postApiUsersPasswordReset(data,params,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiUsersPasswordResetMutationResult = NonNullable<Awaited<ReturnType<typeof postApiUsersPasswordReset>>>
    export type PostApiUsersPasswordResetMutationBody = PasswordResetRequest | undefined
    export type PostApiUsersPasswordResetMutationError = unknown

    export const usePostApiUsersPasswordReset = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiUsersPasswordReset>>, TError,{data?: PasswordResetRequest;params?: PostApiUsersPasswordResetParams}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiUsersPasswordReset>>,
        TError,
        {data?: PasswordResetRequest;params?: PostApiUsersPasswordResetParams},
        TContext
      > => {
      return useMutation(getPostApiUsersPasswordResetMutationOptions(options), queryClient);
    }
    export const postApiUsersPasswordResetToken = (
    token: string,
    resetPasswordWithTokenRequest?: ResetPasswordWithTokenRequest,
    params?: PostApiUsersPasswordResetTokenParams,
 signal?: AbortSignal
) => {


      return axiosInstance<void>(
      {url: `/api/users/password_reset/${token}`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: resetPasswordWithTokenRequest,
        params, signal
    },
      );
    }




export const getPostApiUsersPasswordResetTokenMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiUsersPasswordResetToken>>, TError,{token: string;data?: ResetPasswordWithTokenRequest;params?: PostApiUsersPasswordResetTokenParams}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiUsersPasswordResetToken>>, TError,{token: string;data?: ResetPasswordWithTokenRequest;params?: PostApiUsersPasswordResetTokenParams}, TContext> => {

const mutationKey = ['postApiUsersPasswordResetToken'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiUsersPasswordResetToken>>, {token: string;data?: ResetPasswordWithTokenRequest;params?: PostApiUsersPasswordResetTokenParams}> = (props) => {
          const {token,data,params} = props ?? {};

          return  postApiUsersPasswordResetToken(token,data,params,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiUsersPasswordResetTokenMutationResult = NonNullable<Awaited<ReturnType<typeof postApiUsersPasswordResetToken>>>
    export type PostApiUsersPasswordResetTokenMutationBody = ResetPasswordWithTokenRequest | undefined
    export type PostApiUsersPasswordResetTokenMutationError = ErrorResponse

    export const usePostApiUsersPasswordResetToken = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiUsersPasswordResetToken>>, TError,{token: string;data?: ResetPasswordWithTokenRequest;params?: PostApiUsersPasswordResetTokenParams}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiUsersPasswordResetToken>>,
        TError,
        {token: string;data?: ResetPasswordWithTokenRequest;params?: PostApiUsersPasswordResetTokenParams},
        TContext
      > => {
      return useMutation(getPostApiUsersPasswordResetTokenMutationOptions(options), queryClient);
    }
    export const postApiEmployeeRegistrationCode = (
    registrationCode: string,
    registerEmployeeUserByRegistrationCodeRequest?: RegisterEmployeeUserByRegistrationCodeRequest,
    params?: PostApiEmployeeRegistrationCodeParams,
 signal?: AbortSignal
) => {


      return axiosInstance<LoginSuccessfulResponse>(
      {url: `/api/employee/${registrationCode}`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: registerEmployeeUserByRegistrationCodeRequest,
        params, signal
    },
      );
    }




export const getPostApiEmployeeRegistrationCodeMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiEmployeeRegistrationCode>>, TError,{registrationCode: string;data?: RegisterEmployeeUserByRegistrationCodeRequest;params?: PostApiEmployeeRegistrationCodeParams}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiEmployeeRegistrationCode>>, TError,{registrationCode: string;data?: RegisterEmployeeUserByRegistrationCodeRequest;params?: PostApiEmployeeRegistrationCodeParams}, TContext> => {

const mutationKey = ['postApiEmployeeRegistrationCode'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiEmployeeRegistrationCode>>, {registrationCode: string;data?: RegisterEmployeeUserByRegistrationCodeRequest;params?: PostApiEmployeeRegistrationCodeParams}> = (props) => {
          const {registrationCode,data,params} = props ?? {};

          return  postApiEmployeeRegistrationCode(registrationCode,data,params,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiEmployeeRegistrationCodeMutationResult = NonNullable<Awaited<ReturnType<typeof postApiEmployeeRegistrationCode>>>
    export type PostApiEmployeeRegistrationCodeMutationBody = RegisterEmployeeUserByRegistrationCodeRequest | undefined
    export type PostApiEmployeeRegistrationCodeMutationError = ErrorResponse

    export const usePostApiEmployeeRegistrationCode = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiEmployeeRegistrationCode>>, TError,{registrationCode: string;data?: RegisterEmployeeUserByRegistrationCodeRequest;params?: PostApiEmployeeRegistrationCodeParams}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiEmployeeRegistrationCode>>,
        TError,
        {registrationCode: string;data?: RegisterEmployeeUserByRegistrationCodeRequest;params?: PostApiEmployeeRegistrationCodeParams},
        TContext
      > => {
      return useMutation(getPostApiEmployeeRegistrationCodeMutationOptions(options), queryClient);
    }
    export const getApiEmployeeRegistrationcodesRegistrationCode = (
    registrationCode: string,
    params?: GetApiEmployeeRegistrationcodesRegistrationCodeParams,
 signal?: AbortSignal
) => {


      return axiosInstance<CodeInformation>(
      {url: `/api/employee/registrationcodes/${registrationCode}`, method: 'GET',
        params, signal
    },
      );
    }




export const getGetApiEmployeeRegistrationcodesRegistrationCodeQueryKey = (registrationCode: string,
    params?: GetApiEmployeeRegistrationcodesRegistrationCodeParams,) => {
    return [
    `/api/employee/registrationcodes/${registrationCode}`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetApiEmployeeRegistrationcodesRegistrationCodeQueryOptions = <TData = Awaited<ReturnType<typeof getApiEmployeeRegistrationcodesRegistrationCode>>, TError = ErrorResponse>(registrationCode: string,
    params?: GetApiEmployeeRegistrationcodesRegistrationCodeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiEmployeeRegistrationcodesRegistrationCode>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiEmployeeRegistrationcodesRegistrationCodeQueryKey(registrationCode,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiEmployeeRegistrationcodesRegistrationCode>>> = ({ signal }) => getApiEmployeeRegistrationcodesRegistrationCode(registrationCode,params, signal);





   return  { queryKey, queryFn, enabled: registrationCode !== null && registrationCode !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiEmployeeRegistrationcodesRegistrationCode>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiEmployeeRegistrationcodesRegistrationCodeQueryResult = NonNullable<Awaited<ReturnType<typeof getApiEmployeeRegistrationcodesRegistrationCode>>>
export type GetApiEmployeeRegistrationcodesRegistrationCodeQueryError = ErrorResponse


export function useGetApiEmployeeRegistrationcodesRegistrationCode<TData = Awaited<ReturnType<typeof getApiEmployeeRegistrationcodesRegistrationCode>>, TError = ErrorResponse>(
 registrationCode: string,
    params: undefined |  GetApiEmployeeRegistrationcodesRegistrationCodeParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiEmployeeRegistrationcodesRegistrationCode>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiEmployeeRegistrationcodesRegistrationCode>>,
          TError,
          Awaited<ReturnType<typeof getApiEmployeeRegistrationcodesRegistrationCode>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiEmployeeRegistrationcodesRegistrationCode<TData = Awaited<ReturnType<typeof getApiEmployeeRegistrationcodesRegistrationCode>>, TError = ErrorResponse>(
 registrationCode: string,
    params?: GetApiEmployeeRegistrationcodesRegistrationCodeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiEmployeeRegistrationcodesRegistrationCode>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiEmployeeRegistrationcodesRegistrationCode>>,
          TError,
          Awaited<ReturnType<typeof getApiEmployeeRegistrationcodesRegistrationCode>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiEmployeeRegistrationcodesRegistrationCode<TData = Awaited<ReturnType<typeof getApiEmployeeRegistrationcodesRegistrationCode>>, TError = ErrorResponse>(
 registrationCode: string,
    params?: GetApiEmployeeRegistrationcodesRegistrationCodeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiEmployeeRegistrationcodesRegistrationCode>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiEmployeeRegistrationcodesRegistrationCode<TData = Awaited<ReturnType<typeof getApiEmployeeRegistrationcodesRegistrationCode>>, TError = ErrorResponse>(
 registrationCode: string,
    params?: GetApiEmployeeRegistrationcodesRegistrationCodeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiEmployeeRegistrationcodesRegistrationCode>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiEmployeeRegistrationcodesRegistrationCodeQueryOptions(registrationCode,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const postApiAdministratorusers = (
    createAdministratorUserRequest?: CreateAdministratorUserRequest,
    params?: PostApiAdministratorusersParams,
 signal?: AbortSignal
) => {


      return axiosInstance<void>(
      {url: `/api/administratorusers`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createAdministratorUserRequest,
        params, signal
    },
      );
    }




export const getPostApiAdministratorusersMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiAdministratorusers>>, TError,{data?: CreateAdministratorUserRequest;params?: PostApiAdministratorusersParams}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiAdministratorusers>>, TError,{data?: CreateAdministratorUserRequest;params?: PostApiAdministratorusersParams}, TContext> => {

const mutationKey = ['postApiAdministratorusers'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiAdministratorusers>>, {data?: CreateAdministratorUserRequest;params?: PostApiAdministratorusersParams}> = (props) => {
          const {data,params} = props ?? {};

          return  postApiAdministratorusers(data,params,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiAdministratorusersMutationResult = NonNullable<Awaited<ReturnType<typeof postApiAdministratorusers>>>
    export type PostApiAdministratorusersMutationBody = CreateAdministratorUserRequest | undefined
    export type PostApiAdministratorusersMutationError = ErrorResponse

    export const usePostApiAdministratorusers = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiAdministratorusers>>, TError,{data?: CreateAdministratorUserRequest;params?: PostApiAdministratorusersParams}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiAdministratorusers>>,
        TError,
        {data?: CreateAdministratorUserRequest;params?: PostApiAdministratorusersParams},
        TContext
      > => {
      return useMutation(getPostApiAdministratorusersMutationOptions(options), queryClient);
    }
    export const postApiAdministratorusersCompaniesCompanyIdInvoices = (
    companyId: number,
    params?: PostApiAdministratorusersCompaniesCompanyIdInvoicesParams,
 signal?: AbortSignal
) => {


      return axiosInstance<void>(
      {url: `/api/administratorusers/companies/${companyId}/invoices`, method: 'POST',
        params, signal
    },
      );
    }




export const getPostApiAdministratorusersCompaniesCompanyIdInvoicesMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiAdministratorusersCompaniesCompanyIdInvoices>>, TError,{companyId: number;params?: PostApiAdministratorusersCompaniesCompanyIdInvoicesParams}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiAdministratorusersCompaniesCompanyIdInvoices>>, TError,{companyId: number;params?: PostApiAdministratorusersCompaniesCompanyIdInvoicesParams}, TContext> => {

const mutationKey = ['postApiAdministratorusersCompaniesCompanyIdInvoices'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiAdministratorusersCompaniesCompanyIdInvoices>>, {companyId: number;params?: PostApiAdministratorusersCompaniesCompanyIdInvoicesParams}> = (props) => {
          const {companyId,params} = props ?? {};

          return  postApiAdministratorusersCompaniesCompanyIdInvoices(companyId,params,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiAdministratorusersCompaniesCompanyIdInvoicesMutationResult = NonNullable<Awaited<ReturnType<typeof postApiAdministratorusersCompaniesCompanyIdInvoices>>>

    export type PostApiAdministratorusersCompaniesCompanyIdInvoicesMutationError = ErrorResponse

    export const usePostApiAdministratorusersCompaniesCompanyIdInvoices = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiAdministratorusersCompaniesCompanyIdInvoices>>, TError,{companyId: number;params?: PostApiAdministratorusersCompaniesCompanyIdInvoicesParams}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiAdministratorusersCompaniesCompanyIdInvoices>>,
        TError,
        {companyId: number;params?: PostApiAdministratorusersCompaniesCompanyIdInvoicesParams},
        TContext
      > => {
      return useMutation(getPostApiAdministratorusersCompaniesCompanyIdInvoicesMutationOptions(options), queryClient);
    }
    /**
 * Translates the specified properties into the specified languages using AI. Already-translated languages are never overwritten. The user is notified via portal notification on completion.
 */
export const postApiCompaniesCurrentTranslationsEntityTypeEntityIdAuto = (
    entityType: LocalizationEntityType,
    entityId: string,
    autoTranslateRequest?: AutoTranslateRequest,
    params?: PostApiCompaniesCurrentTranslationsEntityTypeEntityIdAutoParams,
 signal?: AbortSignal
) => {


      return axiosInstance<void>(
      {url: `/api/companies/current/translations/${entityType}/${entityId}/auto`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: autoTranslateRequest,
        params, signal
    },
      );
    }




export const getPostApiCompaniesCurrentTranslationsEntityTypeEntityIdAutoMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCompaniesCurrentTranslationsEntityTypeEntityIdAuto>>, TError,{entityType: LocalizationEntityType;entityId: string;data?: AutoTranslateRequest;params?: PostApiCompaniesCurrentTranslationsEntityTypeEntityIdAutoParams}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiCompaniesCurrentTranslationsEntityTypeEntityIdAuto>>, TError,{entityType: LocalizationEntityType;entityId: string;data?: AutoTranslateRequest;params?: PostApiCompaniesCurrentTranslationsEntityTypeEntityIdAutoParams}, TContext> => {

const mutationKey = ['postApiCompaniesCurrentTranslationsEntityTypeEntityIdAuto'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiCompaniesCurrentTranslationsEntityTypeEntityIdAuto>>, {entityType: LocalizationEntityType;entityId: string;data?: AutoTranslateRequest;params?: PostApiCompaniesCurrentTranslationsEntityTypeEntityIdAutoParams}> = (props) => {
          const {entityType,entityId,data,params} = props ?? {};

          return  postApiCompaniesCurrentTranslationsEntityTypeEntityIdAuto(entityType,entityId,data,params,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiCompaniesCurrentTranslationsEntityTypeEntityIdAutoMutationResult = NonNullable<Awaited<ReturnType<typeof postApiCompaniesCurrentTranslationsEntityTypeEntityIdAuto>>>
    export type PostApiCompaniesCurrentTranslationsEntityTypeEntityIdAutoMutationBody = AutoTranslateRequest | undefined
    export type PostApiCompaniesCurrentTranslationsEntityTypeEntityIdAutoMutationError = ErrorResponse

    export const usePostApiCompaniesCurrentTranslationsEntityTypeEntityIdAuto = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCompaniesCurrentTranslationsEntityTypeEntityIdAuto>>, TError,{entityType: LocalizationEntityType;entityId: string;data?: AutoTranslateRequest;params?: PostApiCompaniesCurrentTranslationsEntityTypeEntityIdAutoParams}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiCompaniesCurrentTranslationsEntityTypeEntityIdAuto>>,
        TError,
        {entityType: LocalizationEntityType;entityId: string;data?: AutoTranslateRequest;params?: PostApiCompaniesCurrentTranslationsEntityTypeEntityIdAutoParams},
        TContext
      > => {
      return useMutation(getPostApiCompaniesCurrentTranslationsEntityTypeEntityIdAutoMutationOptions(options), queryClient);
    }
    /**
 * @deprecated
 */
export const getApiCompaniesCurrentEmployeesRegistrationcodesRegistrationCode = (
    registrationCode: string,
    params?: GetApiCompaniesCurrentEmployeesRegistrationcodesRegistrationCodeParams,
 signal?: AbortSignal
) => {


      return axiosInstance<boolean>(
      {url: `/api/companies/current/employees/registrationcodes/${registrationCode}`, method: 'GET',
        params, signal
    },
      );
    }




export const getGetApiCompaniesCurrentEmployeesRegistrationcodesRegistrationCodeQueryKey = (registrationCode: string,
    params?: GetApiCompaniesCurrentEmployeesRegistrationcodesRegistrationCodeParams,) => {
    return [
    `/api/companies/current/employees/registrationcodes/${registrationCode}`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetApiCompaniesCurrentEmployeesRegistrationcodesRegistrationCodeQueryOptions = <TData = Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesRegistrationcodesRegistrationCode>>, TError = ErrorResponse>(registrationCode: string,
    params?: GetApiCompaniesCurrentEmployeesRegistrationcodesRegistrationCodeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesRegistrationcodesRegistrationCode>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiCompaniesCurrentEmployeesRegistrationcodesRegistrationCodeQueryKey(registrationCode,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesRegistrationcodesRegistrationCode>>> = ({ signal }) => getApiCompaniesCurrentEmployeesRegistrationcodesRegistrationCode(registrationCode,params, signal);





   return  { queryKey, queryFn, enabled: registrationCode !== null && registrationCode !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesRegistrationcodesRegistrationCode>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiCompaniesCurrentEmployeesRegistrationcodesRegistrationCodeQueryResult = NonNullable<Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesRegistrationcodesRegistrationCode>>>
export type GetApiCompaniesCurrentEmployeesRegistrationcodesRegistrationCodeQueryError = ErrorResponse


export function useGetApiCompaniesCurrentEmployeesRegistrationcodesRegistrationCode<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesRegistrationcodesRegistrationCode>>, TError = ErrorResponse>(
 registrationCode: string,
    params: undefined |  GetApiCompaniesCurrentEmployeesRegistrationcodesRegistrationCodeParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesRegistrationcodesRegistrationCode>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesRegistrationcodesRegistrationCode>>,
          TError,
          Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesRegistrationcodesRegistrationCode>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCompaniesCurrentEmployeesRegistrationcodesRegistrationCode<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesRegistrationcodesRegistrationCode>>, TError = ErrorResponse>(
 registrationCode: string,
    params?: GetApiCompaniesCurrentEmployeesRegistrationcodesRegistrationCodeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesRegistrationcodesRegistrationCode>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesRegistrationcodesRegistrationCode>>,
          TError,
          Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesRegistrationcodesRegistrationCode>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCompaniesCurrentEmployeesRegistrationcodesRegistrationCode<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesRegistrationcodesRegistrationCode>>, TError = ErrorResponse>(
 registrationCode: string,
    params?: GetApiCompaniesCurrentEmployeesRegistrationcodesRegistrationCodeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesRegistrationcodesRegistrationCode>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @deprecated
 */

export function useGetApiCompaniesCurrentEmployeesRegistrationcodesRegistrationCode<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesRegistrationcodesRegistrationCode>>, TError = ErrorResponse>(
 registrationCode: string,
    params?: GetApiCompaniesCurrentEmployeesRegistrationcodesRegistrationCodeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesRegistrationcodesRegistrationCode>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiCompaniesCurrentEmployeesRegistrationcodesRegistrationCodeQueryOptions(registrationCode,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const deleteApiCompaniesCurrentEmployeesEmployeeIdPassword = (
    employeeId: string,
    params?: DeleteApiCompaniesCurrentEmployeesEmployeeIdPasswordParams,
 signal?: AbortSignal
) => {


      return axiosInstance<void>(
      {url: `/api/companies/current/employees/${employeeId}/password`, method: 'DELETE',
        params, signal
    },
      );
    }




export const getDeleteApiCompaniesCurrentEmployeesEmployeeIdPasswordMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiCompaniesCurrentEmployeesEmployeeIdPassword>>, TError,{employeeId: string;params?: DeleteApiCompaniesCurrentEmployeesEmployeeIdPasswordParams}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteApiCompaniesCurrentEmployeesEmployeeIdPassword>>, TError,{employeeId: string;params?: DeleteApiCompaniesCurrentEmployeesEmployeeIdPasswordParams}, TContext> => {

const mutationKey = ['deleteApiCompaniesCurrentEmployeesEmployeeIdPassword'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteApiCompaniesCurrentEmployeesEmployeeIdPassword>>, {employeeId: string;params?: DeleteApiCompaniesCurrentEmployeesEmployeeIdPasswordParams}> = (props) => {
          const {employeeId,params} = props ?? {};

          return  deleteApiCompaniesCurrentEmployeesEmployeeIdPassword(employeeId,params,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteApiCompaniesCurrentEmployeesEmployeeIdPasswordMutationResult = NonNullable<Awaited<ReturnType<typeof deleteApiCompaniesCurrentEmployeesEmployeeIdPassword>>>

    export type DeleteApiCompaniesCurrentEmployeesEmployeeIdPasswordMutationError = ErrorResponse

    export const useDeleteApiCompaniesCurrentEmployeesEmployeeIdPassword = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiCompaniesCurrentEmployeesEmployeeIdPassword>>, TError,{employeeId: string;params?: DeleteApiCompaniesCurrentEmployeesEmployeeIdPasswordParams}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteApiCompaniesCurrentEmployeesEmployeeIdPassword>>,
        TError,
        {employeeId: string;params?: DeleteApiCompaniesCurrentEmployeesEmployeeIdPasswordParams},
        TContext
      > => {
      return useMutation(getDeleteApiCompaniesCurrentEmployeesEmployeeIdPasswordMutationOptions(options), queryClient);
    }
